import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <button
            className={`ns-act-btn ns-text-align-right ns-align-items-center ns-clickable ns-color-black ${className}`}
            onClick={() => filter.remove()}
        >
            ×
        </button>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-pt-2 ns-pb-2 ns-selected-outer" style="margin-bottom: 10px;">
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters">
                    {filters.map(filter => (
                        <div
                            key={`${filter.name}: ${filter.value}`}
                            class="ns-selected-filter ns-d-flex ns-align-items-center"
                        >
                            <span class="ns-color-black">{filter.value}</span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                <span
                    class=" ns-text-align-right ns-clear-all"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Clear all filters
                </span>
            </div>
        )
    )
}
